import script from "./PushSpecification.vue?vue&type=script&setup=true&lang=js"
export * from "./PushSpecification.vue?vue&type=script&setup=true&lang=js"

import "./PushSpecification.vue?vue&type=style&index=0&id=a73115a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a73115a2"]])

export default __exports__